import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const MenuItemQuantity = (props) => {
  const classes = classNames(
    'menuItem__quantity',
    { 'primary--background': props.n > 0 },
  );
  const text = props.n > 0 ? `${props.n} ×` : '';
  return (
    <div className={classes}>
      <span>{text}</span>
    </div>
  );
};
MenuItemQuantity.propTypes = {
  n: PropTypes.number,
};

export default MenuItemQuantity;



// WEBPACK FOOTER //
// ./src/components/menu/menu-item-quantity.js